<template>
  <div id="wangeditor">
    <div ref="editorElem"
         style="text-align:left;margin-top:40px">
      <p style="color:red;">【主要问题】</p><br>

      <p style="color:red;">【学情分析】</p><br>

      <p style="color:red;">【课内建议】</p><br>

      <p style="color:red;">【课下建议】</p>

    </div>
  </div>
</template>
<script>
import './index.less'
import E from 'wangeditor'

export default {
  name: 'Editor',
  data() {
    return {
      editor: null,
      editorContent: this.init_content
    }
  },
  props: {
    //初始化内容
    init_content: {
      default: String
    },
    disable: {
      default: Boolean
    }
  },
  mounted() {
    this.editor = new E(this.$refs.editorElem)
    // 过滤掉 emoji 表情
    const emojiRegex =
      /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/g
    // 编辑器的事件，每次改变会获取其html内容
    this.editor.config.onchange = (html) => {
      const filteredHtml = html.replace(emojiRegex, '');
      this.editorContent = filteredHtml;
      this.$emit('submit', this.editorContent);

      // 强制更新编辑器中的内容
      if (html !== filteredHtml) {
        this.editor.txt.html(filteredHtml);  // 更新富文本编辑器内容
      }
    }
    this.editor.config.menus = [
      // 菜单配置
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'fontName', // 字体
      'italic', // 斜体
      'underline', // 下划线
      'strikeThrough', // 删除线
      'foreColor', // 文字颜色
      'backColor', // 背景颜色
      'link', // 插入链接
      'list', // 列表
      'justify', // 对齐方式
      'quote', // 引用
      'table', // 表格
      'undo', // 撤销
      'redo' // 重复
    ]
    this.editor.config.pasteFilterStyle = false
    //本地图片上传：关闭外部图片引入
    this.editor.config.showLinkImg = false
    this.editor.config.uploadFileName = 'file'
    this.editor.config.uploadImgServer = '/upload'
    this.editor.config.debug = true
    this.editor.config.colors = [
      '#000000',
      '#ff0000',
      '#eeece0',
      '#1c487f',
      '#4d80bf',
      '#c24f4a',
      '#8baa4a',
      '#7b5ba1',
      '#46acc8',
      '#f9963b',
      '#ffffff'
    ]
    //配置 自定义处理粘贴的文本内容
    this.editor.config.pasteTextHandle = function (pasteStr) {
      var newStr = pasteStr.replace(/@font-face{[^>]*div.Section0{page:Section0;}/g, '')
      return newStr
    }
    // this.editor.config.customUploadImg=function(files,insert){
    //   //逐个上传
    //   files.forEach(item=>{
    //     upload.image({
    //       url:'',
    //       file:item,
    //       success:(res)=>{
    //         if(res.status ===200){
    //           insert(res.data.url);
    //         }
    //       },
    //       error:()=>{that.$message.error('上传失败');}
    //     });
    //   });
    // };
    //自定义上传图片事件
    this.editor.config.uploadImgHooks = {
      fail: function (xhr, editor, result) {
        console.log('上传失败,原因是' + result)
      },
      error: function (xhr, editor) {
        console.log('上传出错')
      },
      timeout: function (xhr, editor) {
        console.log('上传超时')
      },
      customInsert: function (insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        var url = result.url
        insertImg(url)
      }
    }
    this.editor.create() // 创建富文本实例
    this.editor.$textElem.attr('contenteditable', this.disable) //设置不可编辑
    if (this.init_content != '') {
      this.editor.txt.html(this.init_content)
    }
  },
  methods: {
    setContent() {
      this.$nextTick(() => {
        if (this.init_content != '') {
          this.editor.txt.html(this.init_content)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/global-components/WangEditor/index.vue